export enum NamedElementsRequestTypes {
  SetNamedElementRequest = 'namedelements.set.request',
  SetNamedElementSuccess = 'namedelements.set.success',
  SetNamedElementFailure = 'namedelements.set.failure',
  GetAllNamedElementsRequest = 'namedelements.getall.request',
  GetAllNamedElementsSuccess = 'namedelements.getall.success',
  GetAllNamedElementsFailure = 'namedelements.getall.failure',
  ArchiveNamedElementRequest = 'namedelements.archive.request',
  ArchiveNamedElementSuccess = 'namedelements.archive.success',
  ArchiveNamedElementFailure = 'namedelements.archive.failure',
  ArchiveMultiNamedElementsRequest = 'namedelements.archivemulti.request',
  ArchiveMultiNamedElementsSuccess = 'namedelements.archivemulti.success',
  ArchiveMultiNamedElementsFailure = 'namedelements.archivemulti.failure',
  SilenceNamedElementRequest = 'namedelements.silence.request',
  SilenceNamedElementSuccess = 'namedelements.silence.success',
  SilenceNamedElementFailure = 'namedelements.silence.failure',
  UnSilenceNamedElementRequest = 'namedelements.unsilence.request',
  UnSilenceNamedElementSuccess = 'namedelements.unsilence.success',
  UnSilenceNamedElementFailure = 'namedelements.unsilence.failure',
  ValidateNamedElementRequest = 'namedelements.validate.request',
  ValidateNamedElementSuccess = 'namedelements.validate.success',
  ValidateNamedElementFailure = 'namedelements.validate.failure',
  GetSuggestedNamedElementRequest = 'namedelements.getsuggestedelement.request',
  GetSuggestedNamedElementSuccess = 'namedelements.getsuggestedelement.success',
  GetSuggestedNamedElementFailure = 'namedelements.getsuggestedelement.failure',
  SetSuggestedNamedElementRequest = 'namedelements.setsuggestedelement.request',
  SetSuggestedNamedElementSuccess = 'namedelements.setsuggestedelement.success',
  SetSuggestedNamedElementFailure = 'namedelements.setsuggestedelement.failure',
}

export interface NamedElementCaptureOptions {
  watched: boolean;
  rageClicksBlocked: boolean;
  deadClicksBlocked: boolean;
}
